

export default {
  SET_KATEGORI_LIST(state, payload){
    state.kategoriList = payload
  },
  SET_RH_TOTAL(state, payload){
    state.totalRHRecords = payload
  }
}
